import { apiClient } from '@borradh-workspace/api-client';
import {
  type ClaireBlockedCampaignsResponseContract,
  claireBlockedCampaignsResponseSchema,
} from '@borradh-workspace/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const claireBlockedCampaignsQueryKey = (organizationId: string) =>
  ['organization', organizationId, 'claire-blocked-campaigns'] as const;

export const getClaireBlockedCampaignsQueryOptions = (organizationId: string) =>
  queryOptions({
    queryKey: claireBlockedCampaignsQueryKey(organizationId),
    queryFn: () =>
      apiClient.get<ClaireBlockedCampaignsResponseContract>(
        `organizations/${organizationId}/claire-blocked-campaigns`,
        { schema: claireBlockedCampaignsResponseSchema }
      ),
    enabled: !!organizationId,
  });

/** Meta ad campaign ids Claire does not reply to. */
export const useGetClaireBlockedCampaigns = (organizationId: string) => {
  const query = useQuery(getClaireBlockedCampaignsQueryOptions(organizationId));
  return {
    campaignIds: query.data?.campaignIds ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
};
